var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFileImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_418_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5 14.6667H27.5183",
    stroke: "#141C25",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33331 27.5L14.6666 20.1667C16.368 18.5295 18.4653 18.5295 20.1666 20.1667L29.3333 29.3333",
    stroke: "#141C25",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6667 25.6667L27.5 23.8333C29.2014 22.1962 31.2987 22.1962 33 23.8333L36.6667 27.5",
    stroke: "#141C25",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 22C5.5 26.3761 7.23839 30.5729 10.3327 33.6673C13.4271 36.7616 17.6239 38.5 22 38.5C26.3761 38.5 30.5729 36.7616 33.6673 33.6673C36.7616 30.5729 38.5 26.3761 38.5 22C38.5 17.6239 36.7616 13.4271 33.6673 10.3327C30.5729 7.23839 26.3761 5.5 22 5.5C17.6239 5.5 13.4271 7.23839 10.3327 10.3327C7.23839 13.4271 5.5 17.6239 5.5 22Z",
    stroke: "#141C25",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_418_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileImage);
export default __webpack_public_path__ + "static/media/Icon_File_Image.238bdb76a6c398734aaf1159565af5e8.svg";
export { ForwardRef as ReactComponent };